import { ImageActionType, ImageObjectFit } from "@wuilt/section-preview";
import { nanoid } from "nanoid";
function migrateSettings(id, old) {
  // has been migrated before
  if (old.desktop) return old;
  const castedOld = old;
  return {
    id,
    desktop: {
      action: {
        type: castedOld?.scalable ? ImageActionType.Scale_Up : ImageActionType.Do_Nothing
      },
      objectFit: ImageObjectFit?.Cover,
      src: castedOld?.url || castedOld,
      crop: {
        backgroundPosition: castedOld?.backgroundPosition,
        backgroundSize: castedOld?.backgroundSize,
        zoom: castedOld?.zoom
      }
    }
  };
}
export function migrateElement(id, old) {
  const settings = migrateSettings(id, old);
  return {
    id: id || `Image:${nanoid()}`,
    type: "Image",
    settings
  };
}
//# sourceMappingURL=image-migration.js.map